import { type ClientInferRequest } from "@ts-rest/core";

import { client } from "../client";
import { type apiContract } from "../contract";

type GetCollectOrderRequest = ClientInferRequest<
  typeof apiContract.v1.collect.children.getOrders
>;

type GetCollectOrderArgs = GetCollectOrderRequest["params"] &
  GetCollectOrderRequest["query"];

export async function getCollectOrder({
  childId,
  childCardHex,
  tillId
}: GetCollectOrderArgs) {
  const response = await client.v1.collect.children.getOrders({
    params: {
      tillId
    },
    query: {
      childId,
      childCardHex
    }
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}

type CollectOrderLinesRequest = ClientInferRequest<
  typeof apiContract.v1.collect.children.collectOrderLines
>;

export type CollectOrderLinesArgs = CollectOrderLinesRequest["params"] &
  CollectOrderLinesRequest["query"] & {
    orderLines: Omit<CollectOrderLinesRequest["body"][number], "type">[];
  };

export async function collectOrderLines({
  tillId,
  childId,
  profileId,
  orderLines
}: CollectOrderLinesArgs) {
  const response = await client.v1.collect.children.collectOrderLines({
    params: {
      tillId,
      childId
    },
    query: {
      profileId
    },
    body: orderLines.map((line) => ({
      ...line,
      type: "collect"
    }))
  });

  if (response.status === 204) {
    return response.body;
  }

  throw response;
}
